import PropTypes from 'prop-types';
import {useRef} from 'react';
import {connect} from 'react-redux';
import DefineFieldPropType from '../../propTypes/DefineField.proptype';
import FieldContainerPropType from '../../propTypes/FieldContainer.proptype';
import getIsExpiryDateWave2Enabled from '../selectors/getIsExpiryDateWave2Enabled';
import dateCharsOnly from './field-validation/dateCharsOnly';
import InputField from './InputField';

export function ExpiryInputField(props) {
  const hasBeenChangedRef = useRef(false);

  const handleChange = onChange => (event) => {
    event?.preventDefault();
    
    onChange(event);
    
    if (!hasBeenChangedRef.current) {
      hasBeenChangedRef.current = true;
    }
    
    if (props.fieldContainer && props.fieldContainer.validate && props.isExpiryDateWave2Enabled) {
      props.fieldContainer.validate(event.target.value);
    }
  };
  
  const handleSlash = (event) => {
    event?.preventDefault();
    if (event.target.value?.length >= 2 && !event.target.value?.includes('/')
      && !event.target.value?.includes('-')) {
      event.target.value += '/';
    }
  };
  
  const handleCharacterLimit = (onChange, event, maxLength) => {
    const nonLimitingKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'];

    if (props.value?.length >= maxLength && !nonLimitingKeys.includes(event.key)) {
      event.preventDefault();
      return true;
    }
    return false;
  };

  const handleKeyDown = (onChange, event) => {
    if (props.isExpiryDateWave2Enabled && handleCharacterLimit(onChange, event, 7)) {
      return;
    }
    
    if (event.key === 'Backspace' && props.definedField.name === 'expiryDate' && props.value?.length >= 3) {
      if (props.value.slice(-1) === '/' && props.value.split('/').length - 1 === 1) {
        event.target.value = props.value?.substr(0, 1);
        handleChange(onChange)(event);
      } else if (props.value.slice(event.target.selectionStart - 1, event.target.selectionStart) === '/'
        && props.value.split('/').length - 1 === 1
        && event.target.selectionStart !== props.value.length) {
        event.target.selectionStart = props.value.length;
        handleChange(onChange)(event);
      }
    } else if (event.key === '/' && props.value.search('/') !== -1) {
      event.preventDefault();
    } else if (event.key.match(/^[a-z$£&+,:;=?[\]@#|{}'<>.^*()%!-\s]*$/)) {
      event.preventDefault();
    }
  };
  
  const newDefinedField = {
    ...props.definedField,
    validate: [...props.definedField?.validate, dateCharsOnly()],
    placeholder: props.isExpiryDateWave2Enabled
      ? 'checkout.payment.method.field.label.expires.date.text.inputfield.placeholder'
      : 'checkout.payment.method.field.label.expires.date.text.inputfield',
  };
  
  const newProps = {
    ...props,
    onKeyDown: handleKeyDown,
    handleSlash,
    definedField: newDefinedField,
    onChange: handleChange,
  };
  
  return (
    <InputField
      {...newProps}
    />
  );
}

const mapStateToProps = state => ({
  isExpiryDateWave2Enabled: getIsExpiryDateWave2Enabled(state),
});

ExpiryInputField.propTypes = {
  legacyNames: PropTypes.shape({
    wrappedClassName: PropTypes.string,
  }).isRequired,
  definedField: PropTypes.shape(DefineFieldPropType).isRequired,
  customContainerId: PropTypes.string,
  fieldContainer: PropTypes.shape(FieldContainerPropType).isRequired,
  predictionComponent: PropTypes.func,
  emptyPredictionsFallback: PropTypes.node,
  validationCallback: PropTypes.objectOf(PropTypes.func),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  tabIndex: PropTypes.number,
  disabled: PropTypes.bool,
  fieldNamePrefix: PropTypes.string,
  placeholder: PropTypes.string,
  ariaAutocomplete: PropTypes.string,
  ariaActivedescendant: PropTypes.string,
  ariaControls: PropTypes.string,
  autoCompleteState: PropTypes.string,
  predictions: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
  fieldType: PropTypes.symbol,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyPress: PropTypes.func,
  onKeyUp: PropTypes.func,
  onSelect: PropTypes.func,
  handleFocus: PropTypes.func,
  icon: PropTypes.node,
  clearInput: PropTypes.func,
  handleSearch: PropTypes.func,
  hideLabel: PropTypes.bool,
  showCurrentLocation: PropTypes.bool,
  handleChange: PropTypes.func,
  isExpiryDateWave2Enabled: PropTypes.bool,
};

export default connect(mapStateToProps)(ExpiryInputField);
